// in src/posts.js
import React from 'react';
import { BooleanField, ImageField, ImageInput, Filter, DeleteButton, DateField, RichTextField, SimpleShowLayout, Show, ShowButton, SimpleList, BooleanInput, List, Edit, Create, Datagrid, ReferenceField, TextField, EditButton, ReferenceInput, required, SelectInput, SimpleForm, TextInput } from 'react-admin';
import { RichTextInput } from 'ra-input-rich-text';
import InputUploadInput from '../mui/field/UploadInput';
import { useMediaQuery } from '@mui/material';

//Utils
import Validators from './renderFields/validatorsFields';

export const SliderList = (props) => {
    // Check if the screen size is small
    const isSmall = useMediaQuery((theme) => theme.breakpoints.down('sm'));

    return (
        <List {...props} filters={<SliderFilter />}>
            {isSmall ? (
                <SimpleList
                    primaryText={record => record.title}
                    tertiaryText={record => new Date(record.createdAt).toLocaleDateString()}
                />
            ) : (
                <Datagrid>
                    <TextField source="id" />
                    <ImageField source="image" label="Imagen"/>
                    <TextField source="title" label="Título"/>
                    <BooleanField source="state" label="Estado"/>
                    <EditButton />
                    <ShowButton />
                    <DeleteButton />
                </Datagrid>
            )}
        </List>
    );
};

const SliderFilter = (props) => (
    <Filter {...props}>
        <TextInput label="Buscar" source="title" alwaysOn />
    </Filter>
);

const SliderTitle = ({ record }) => {
    return <span>Slider {record ? `"${record.title}"` : ''}</span>;
};

export const SliderEdit = (props) => (
    <Edit title={<SliderTitle />} {...props}>
        <SimpleForm>
            <TextInput source="id" disabled/>
            <TextInput source="title" label="Título" validate={[Validators.required]}/>
            <InputUploadInput source="image" label="Imagen" validate={[Validators.required]}/>
            <TextInput source="link" label="Link" validate={[Validators.required]}/>
            <BooleanInput source="new_tab" label="Nueva Pestaña"/>
            <BooleanInput source="state" label="Estado"/>
        </SimpleForm>
    </Edit>
);



console.log('SliderCreate component rendered');

export const SliderCreate = (props) => (
    <Create {...props}>
        <p>Item SliderCreate: {JSON.stringify(props)}</p>
        <SimpleForm >
            <TextInput source="title" label="Título" validate={[Validators.required]}/>
            <InputUploadInput source="image" label="Imagen" validate={[Validators.required]} />
            <TextInput source="link" label="Link" hola="mundo" validate={[Validators.required]}/>
            <BooleanInput source="new_tab" label="Nueva Pestaña" defaultValue={true}/>
            <BooleanInput source="state" label="Estado" defaultValue={true}/>
        </SimpleForm>
    </Create>
);

export const SliderShow = (props) => (
    <Show title={<SliderTitle />} {...props}>
        <SimpleShowLayout>
            <TextField source="title" label="Título"/>
            <ImageField source="image" label="Imagen"/>
            <TextField source="link" label="Link"/>
            <BooleanField source="new_tab" label="Nueva Pestaña"/>
            <BooleanField source="state" label="Estado"/>
            <DateField label="Fecha Actualización" source="updatedAt" />
            <DateField label="Fecha Publicación" source="createdAt" />
        </SimpleShowLayout>
    </Show>
);
